import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormlyModule } from '@ngx-formly/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { FormlyErrorComponent } from '../formly-error.component';
import { FieldLabelRowComponent } from './field-label-row.component';
import { FormlyDataCyDirective } from '../../directives/formly-data-cy.directive';
import { emailValidator } from '../../validators/email';
import { ClearFieldButtonComponent } from './clear-field-button.component';
import { ClearableFieldType } from './clearable-field.type';

@Component({
  selector: 'formly-field-custom-email',
  template: `
    <!--
      Width classes from field.className are already applied by formly to the host <formly-field>.
      Re-applying them here compounded them: a half-width field rendered at 50% of 50%, so the
      email box was a quarter of the row instead of half. The inner field just fills its host.
    -->
    <mat-form-field class="w-full" [class.mat-form-field-invalid]="formControl.invalid && formControl.touched">
      <!-- No required sign neede here it's in the label-->
      <mat-label>
        <app-field-label-row [label]="props.label" [required]="props.required" [info]="props.info"></app-field-label-row>
      </mat-label>
      <input #input type="email" matInput [required]="props.required" [formControl]="formControl" [formlyAttributes]="field" [formlyDataCy]="field" />
      <span class="dd-clear-suffix" matSuffix>
        <app-clear-field-button
          [field]="field"
          [hasValue]="hasClearableValue()"
          [disabled]="isDisabled()"
          [readOnly]="isReadOnly()"
          [ariaLabel]="clearAriaLabel()"
          [focusTarget]="input"
          (clearSelection)="clear()" />
      </span>
      @if (props.description) {
        <mat-hint>{{ props.description }}</mat-hint>
      }
    </mat-form-field>
    <app-formly-error [field]="field"></app-formly-error>
  `,
  imports: [
    ReactiveFormsModule,
    FormlyModule,
    MatInputModule,
    FormlyErrorComponent,
    FormlyDataCyDirective,
    ClearFieldButtonComponent,
    FieldLabelRowComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyEmailType extends ClearableFieldType implements OnInit {
  constructor() {
    super();
  }

  ngOnInit() {
    this.formControl.setValidators(emailValidator);
  }
}
